import {ValueObject} from '@s-ui/domain'

export class VehicleOfferValueObject extends ValueObject {
  /**
   * @param {OfferPriceValueObject} offerPrice
   * @param {VehicleEntity} vehicle
   * */

  toJSON() {
    const offerPrice = this._offerPrice && this._offerPrice.toJSON().spotPrice
    return {
      ...(offerPrice && {offerPrice}),
      ...this._vehicle.toJSON()
    }
  }
}
